export const environment = {
    production: false,
    apiDomain: 'p57p2gxw8a.execute-api.ap-southeast-2.amazonaws.com',
    webSocketDomain: '84vwvhhee5.execute-api.ap-southeast-2.amazonaws.com',
    apiBasePath: 'dev'
};
